import { Navigate, Route, Routes } from 'react-router-dom';
import RequestConsult from '../pages/facilityConsult/RequestConsult';
import FacilityLayout from '../pages/layout/FacilityLayout';
import CreateConsult from '../pages/facilityConsult/CreateConsult';
import Waiting from '../pages/facilityConsult/Waiting';
import SignInComponent from '../pages/login/SignInComponent';
import ForgotPassword from '../pages/login/ForgotPassword';
import ConsultRequested from '../pages/dashboard/ConsultRequested';
import ResetPassword from '../pages/login/ResetPassword';
import RoleProtectedRoute from './RoleProtectedRoute';
import PrivateRoute from './PrivateRoute';
import TwoFactorAuthentication from '../pages/login/TwoFactorAuthentication';
import AccessDenied from '../pages/login/access-denied';
import LinkExpire from '../pages/login/LinkExpire';
import MoreDetails from '../pages/moreDetails/consultMoreDetails';
import ZoomCall from '../pages/zoom/ZoomCall';
import ZoomCallEnd from '../pages/zoom/ZoomCallEnd';
import { ROLES } from '../roles';
import ReSubmitOrCancelConsult from '../pages/facilityConsult/ReSubmitOrCancelConsult';

const Routing = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Navigate to="/facility/login" replace />} />
      <Route path="/facility/reset-password/:uid" element={<ResetPassword />} />
      <Route path="/facility/reset-password" element={<ResetPassword />} />
      <Route path="/facility/login" element={<SignInComponent />} />
      <Route path="/facility/2fa" element={<TwoFactorAuthentication />} />
      <Route path="/facility/forgot-password" element={<ForgotPassword />} />
      <Route path="/facility/access-denied" element={<AccessDenied />} />
      <Route path="/facility/link-expire" element={<LinkExpire />} />

      {/* Authenticated routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/facility">
          <Route element={<FacilityLayout />}>
            <Route
              element={
                <RoleProtectedRoute allowedRoles={[ROLES.FACILITY_USER]} />
              }
            >
              <Route path="request" element={<RequestConsult />} />
            </Route>
            <Route path="waiting-room" element={<Waiting />} />
            <Route path="waiting-room/:consultId" element={<Waiting />} />
            <Route path="create" element={<CreateConsult />} />
            <Route path="create/:consultId" element={<CreateConsult />} />
            <Route
              element={
                <RoleProtectedRoute allowedRoles={[ROLES.CASE_MANAGER]} />
              }
            >
              <Route path="consults" element={<ConsultRequested />} />
              <Route path="more-details" element={<MoreDetails />} />
            </Route>
            <Route path="re-submit" element={<ReSubmitOrCancelConsult />} />
          </Route>
        </Route>
      </Route>

      <Route element={<PrivateRoute />}>
        <Route
          path="/zoom-call/:role/:username/:meetingId/:meetingPassword/:caseId/:zoomKey"
          element={<ZoomCall />}
        />
        <Route
          path="/zoom-call-end/:meetingId/:caseId"
          element={<ZoomCallEnd />}
        />
      </Route>
    </Routes>
  );
};
export default Routing;
